import httpClient from "../utils/httpClient";

export const loginValidationApi = async (payload) => {
    const response = await httpClient.post("/Authentication/checkLoginValidation", payload);
    return response.data;
};

export const loginApi = async (payload) => {
    const response = await httpClient.post("/Authentication/login", payload);
    return response.data;
};

export const logoutApi = async (payload) => {
    const response = await httpClient.post("/Authentication/logout", {});
    return response.data;
};

export const getCustomerListApi = async (payload) => {
    const response = await httpClient.post("/Authentication/GetCustomerList", payload);
    return response.data;
};